import axios from "axios";
import useLoginStore from "../../stores/loginStore";

export interface IRefreshResponse {
  token: string;
}

/**
 * 토큰을 리프레시합니다.
 * 현재 토큰을 사용하여 새로운 토큰을 발급받습니다.
 * 
 * 주의: 순환 참조를 피하기 위해 apiPost 대신 axios를 직접 사용합니다.
 */
export const apiRefreshToken = async (): Promise<IRefreshResponse> => {
  const token = useLoginStore.getState().token;
  const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT || "https://api.snscbt.com";
  
  const response = await axios.post(
    `${API_ENDPOINT}/auth/refresh`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  
  if (!response.data.success || !response.data.data?.token) {
    throw new Error(response.data.message || "Token refresh failed");
  }
  
  return response.data.data;
};